if (!window.$) {
  window.$ = require('jquery')
}
if (!window.jQuery) {
  window.jQuery = window.$
}

require('./plugins')
require('./custom')
